// Where each timeline row opens. Pure, import-light so it is unit-testable
// (same pattern as plDatePresets.js / reconciliationTabs.js).
//
// Every target is a screen that ALREADY owns the record — this page rebuilds none
// of them. Verified against frontend/src/App.js on 2026-07-22:
//   /procurement/suppliers/:id        App.js:304   (?edit=1 opens in edit mode)
//   /procurement/invoices/:id         App.js:313
//   /procurement/payments/:id         App.js:315   (?invoice_id= pre-filters)
//   /finance/journal-reconciliation   ?tab=/?queue_id=/?je_id= added 2026-07-22
//
// GCS bucket for stored invoice documents. publicUrl() in
// backend/utils/document-store.js builds the same URL server-side; the path
// carries a 128-bit CSPRNG token so objects are unguessable, but the link never
// expires and carries no auth check.
const GCS_BUCKET = 'excthumbs';

export function documentUrl(gcsPath) {
  if (!gcsPath) return '';
  return `https://storage.googleapis.com/${GCS_BUCKET}/${String(gcsPath)
    .split('/')
    .map(encodeURIComponent)
    .join('/')}`;
}

// A bank/card row opens the evidence drawer in the All Transactions tab.
export function bankTxnLink(queueId) {
  if (!queueId) return '';
  return `/finance/journal-reconciliation?tab=transactions&queue_id=${encodeURIComponent(queueId)}`;
}

// A GL chip opens the journal entry's detail dialog.
export function journalEntryLink(jeId) {
  if (!jeId || String(jeId) === '0') return '';
  return `/finance/journal-reconciliation?tab=journal-entries&je_id=${encodeURIComponent(jeId)}`;
}

// Fallback when a counterparty's transactions are not resolved to a key yet:
// search the raw memo/counterparty text instead of dead-ending.
export function transactionSearchLink(text) {
  if (!text) return '';
  return `/finance/journal-reconciliation?tab=transactions&search=${encodeURIComponent(text)}`;
}

export function supplierLink(supplierId, { edit = false } = {}) {
  if (!supplierId) return '';
  return `/procurement/suppliers/${supplierId}${edit ? '?edit=1' : ''}`;
}

export function invoiceLink(eventId) {
  const m = /^inv:(\d+)$/.exec(String(eventId || ''));
  return m ? `/procurement/invoices/${m[1]}` : '';
}

// A payment ROW is a payment ALREADY made against an invoice. Its Open must show that invoice
// (read-only detail, with its paid/outstanding status) — NOT the "record a new payment" form,
// which auto-popped an apply-payment dialog on an already-settled payment. The payment event
// carries pay:<invoice_id>, so route it to the same invoice detail as the invoice row.
export function paymentInvoiceLink(eventId) {
  const m = /^pay:(\d+)$/.exec(String(eventId || ''));
  return m ? `/procurement/invoices/${m[1]}` : '';
}

// Resolve the primary Open target for a timeline row.
export function primaryLinkForEvent(ev, supplierId) {
  if (!ev) return '';
  switch (ev.event_kind) {
    case 'bank_txn':
      return bankTxnLink(ev.queue_id) || transactionSearchLink(ev.memo);
    case 'invoice':
      return invoiceLink(ev.event_id);
    case 'payment':
      return paymentInvoiceLink(ev.event_id) || supplierLink(supplierId);
    default:
      return '';
  }
}
